import { useAuth } from '@/context/AuthContext';
import { api } from '@/lib/trpc/react';
import { useEffect } from 'react';

export const ChurnekyLoader = () => {
  const { user } = useAuth();
  const checkChurnkey = (hash: string) => {
    if (
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      (window as any).churnkey &&
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      typeof (window as any).churnkey.check === 'function' &&
      user?.stripeId
    ) {
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      (window as any).churnkey.check('pause', {
        customerId: user.stripeId,
        authHash: hash,
        appId: 'rj4lblz7e',
        mode: process.env.NODE_ENV === 'development' ? 'test' : 'live',
        provider: 'stripe',
        softWall: false,
        forceCheck: false,
      });
    }
  };

  useEffect(() => {
    if (user?.stripeId) {
      getHash();
    }
  }, [user]);

  const { mutate: getHash } = api.churnkey.hashMutation.useMutation({
    onSuccess: (hash) => {
      if (hash) {
        checkChurnkey(hash);
      }
    },
  });
  return null;
};
